<template>
  <div>
  <div class="header-banner">
    <div class="container">
      <h1>{{ title }}</h1>

      <Tabs
        v-if="this.currentStep"
        :steps="this.steps"
        :currentStep="this.currentStep.index"
        @goTo="changeStep"></Tabs>

    </div>
  </div>
      <div id="user-info">
         <div class="container container-fluid mt-3 mt-xl-0">
            <ul>
               <UserInfo />
            </ul>
         </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Tabs from './Tabs.vue'
import UserInfo from './UserInfo.vue'

export default {
  components: { Tabs, UserInfo },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      title: 'global/getTitle',
      subTitle: 'global/getSubTitle',
      currentStep: 'userJourney/getCurrentStep',
      currentStepIndex: 'userJourney/getCurrentStepIndex',
      steps: 'userJourney/getSteps'
    })
  },
  methods: {
    ...mapActions({
      goToStep: 'userJourney/goToStep'
    }),
    changeStep(index) {
      if (index != this.currentStepIndex && this.steps[index].enabled) {
        this.goToStep(index)
      }
    }
  },
  mounted() {}
}
</script>

<style>
</style>
